<template>
  <v-tabs v-model="tab" background-color="transparent" grow @change="tabChange">
    <v-tab v-if="alphabetic">Alpha</v-tab>
    <v-tab v-if="wild">Search</v-tab>
    <v-tab v-if="labels">Labels</v-tab>
    <v-tabs-items v-model="tab" class="px-2 sec-tools" style="height:50px">
      <v-tab-item v-if="alphabetic">
        <div>
          <span
            v-for="term in letters"
            :key="term"
            class="letter"
            :class="{ active: selectedLetter === term }"
            @click="searchAlpha(term)"
            >{{ term }}
          </span>
          .
          <span
            class="letter"
            :class="{ active: selectedLetter === 'ALL' }"
            @click="searchAlpha('ALL')"
            >All</span
          >
        </div>
      </v-tab-item>
      <v-tab-item v-if="wild">
        <v-text-field
          style="width:100%"
          v-model="search"
          append-icon="mdi-magnify"
          single-line
          hide-details
          solo
          dense
          flat
          placeholder="Search..."
          @keyup="onWildSearch"
          ref="wildSearchIpt"
          background-color="rgba(255, 255, 255, 0)"
        ></v-text-field>
      </v-tab-item>
      <v-tab-item v-if="labels">
        <hi-label-selector
          :type="labels"
          no-color
          @select="onLabel"
        ></hi-label-selector>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
import HiLabelSelector from "@/components/HiLabelSelector";

function searchAlpha(value, search) {
  return (
    value != null &&
    search != null &&
    typeof value === "string" &&
    value
      .toString()
      .toUpperCase()
      .indexOf(search) === 0
  );
}

const letters = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
];
export default {
  name: "HiDatatableSearch",
  components: {
    HiLabelSelector
  },
  props: {
    /** built in alphabetic search
     * [key:String]
     * */
    alphabetic: {
      type: Array
    },
    /**
     * built in wild search
     * [key:String]
     */
    wild: {
      type: Array
    },
    /**
     * built in label search
     * "leads" or others
     */
    labels: {
      type: String
    },
    /**
     * built in has value search
     * [{key:data key, label: String}]
     */
    hasValue: {
      type: Array
    }
  },
  data() {
    return {
      tab: null,
      letters: letters,
      search: null,
      selectedLetter: "ALL"
    };
  },
  methods: {
    searchAlpha(term) {
      term = term.toUpperCase();
      if (term === this.selectedLetter) return;
      this.selectedLetter = term;
      if (term === "ALL") {
        this.$emit("search", "", () => true);
      } else {
        this.$emit("search", term, (value, search, item) => {
          for (let i = 0; i < this.alphabetic.length; i++) {
            if (searchAlpha(item[this.alphabetic[i]], term)) return true;
          }

          return false;
        });
      }
    },
    onWildSearch() {
      // console.log("wild: " + this.search);
      this.$emit("search", this.search, (value, search, item) => {
        // console.log(
        //   "wild: " +
        //     this.search +
        //     " - " +
        //     item[this.wild] +
        //     " : " +
        //     item[this.wild].indexOf(this.search)
        // );
        const s = this.search.toLowerCase();
        if (!s.length) return true;
        for (let i = 0; i < this.wild.length; i++) {
          const val = item[this.wild[i]];
          if (!val || !val.length) continue;
          if (val.toLowerCase().indexOf(s) !== -1) return true;
        }

        return false;
      });
    },
    onLabel(label) {
      this.$emit("search", label, (value, search, item) => {
        return item.labels && item.labels.includes(label);
      });
    },
    tabChange() {
      setTimeout(() => {
        const ipt = this.$refs.wildSearchIpt;
        if (ipt && ipt.focus) ipt.focus();
      }, 200);
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
::v-deep .v-tabs-bar {
  height: 35px;
}
::v-deep .v-tab {
  font-size: 0.6em;
}
//get tab content centered
::v-deep .v-window__container {
  height: 100% !important;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
::v-deep .v-window-item {
  width: 100%;
  text-align: center;
}
.letter {
  padding-left: 5px;
  padding-right: 5px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  opacity: 0.5;
}
.letter.active {
  color: $gold-dark;
  opacity: 1;
  cursor: default;
  text-decoration: underline;
}
</style>
